import { RouteObject } from "react-router-dom";
import { Brands } from "./list";

export const BrandRouter: RouteObject = {
  path: "/brands",
  handle: { crumb: () => "Cadastros / Geral / Marcas" },
  children: [
    {
      index: true,
      element: <Brands />,
    },
  ],
  errorElement: <h1>Route not found!</h1>,
};
